import * as RouteLink from "./constants/routeLink";
import Home from "./pages/Home/index";
import Friends from "./pages/Friends/index";
import Earn from "./pages/Earn/index";
import Task from "./pages/Task/index";
import DailyRewards from "./pages/DailyRewards/index";
import ShopDogs from "./pages/ShopDogs/index";
import Boost from "./pages/Boost/index";
// import Deposit from "./pages/deposit/index";
import Withdraw from "./pages/Withdraw/index";
import Top from "./pages/Top/index";
import Spin from "./pages/Spin/index";
import Deposits from "./pages/Deposits";
import History from "./pages/History";
// import Deposit from "./pages/deposit";
const routers = [
  {
    path: RouteLink.HOME,
    exact: false,
    name: "Home",
    key: "Home",
    main: ({ match, history, routers }) => (
      <Home match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.EARN,
    exact: false,
    name: "Earn",
    key: "Earn",
    main: ({ match, history, routers }) => (
      <Earn match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.FRIENDS,
    exact: false,
    name: "Friends",
    key: "Friends",
    main: ({ match, history, routers }) => (
      <Friends match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.TASK,
    exact: false,
    name: "Task",
    key: "Task",
    main: ({ match, history, routers }) => (
      <Task match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.DAILY_REWARD,
    exact: false,
    name: "DailyRewards",
    key: "DailyRewards",
    main: ({ match, history, routers }) => (
      <DailyRewards match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.SHOP_DOGS,
    exact: false,
    name: "ShopDogs",
    key: "ShopDogs",
    main: ({ match, history, routers }) => (
      <ShopDogs match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.BOOST,
    exact: false,
    name: "Boost",
    key: "Boost",
    main: ({ match, history, routers }) => (
      <Boost match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  // {
  //   path: RouteLink.DEPOSIT,
  //   exact: false,
  //   name: "Deposit",
  //   key: "Deposit",
  //   main: ({ match, history, routers }) => (
  //     <Deposit match={match} history={history} routers={routers} />
  //   ),
  //   routers: [
  //   ]
  // },
  {
    path: RouteLink.WITHDRAW,
    exact: false,
    name: "Withdraw",
    key: "Withdraw",
    main: ({ match, history, routers }) => (
      <Withdraw match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.TOP,
    exact: false,
    name: "Top",
    key: "Top",
    main: ({ match, history, routers }) => (
      <Top match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.SPIN,
    exact: false,
    name: "Spin",
    key: "Spin",
    main: ({ match, history, routers }) => (
      <Spin match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.DEPOSIT,
    exact: false,
    name: "Deposits",
    key: "Deposits",
    main: ({ match, history, routers }) => (
      <Deposits match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  },
  {
    path: RouteLink.HISTORY,
    exact: false,
    name: "History",
    key: "History",
    main: ({ match, history, routers }) => (
      <History match={match} history={history} routers={routers} />
    ),
    routers: [
    ]
  }

]


export default routers;